import clsx from "clsx";
import { useAuth } from "../../lib/hooks";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSignOutMutation } from "../../api/authApiSlice";
import { clearCredentials } from "../../stores/authSlice";
import { apiSlice } from "../../api/apiSlice";

export default function AuthButton() {
    const authenticated = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [signOut, { isLoading }] = useSignOutMutation();

    const handleLogout = async () => {
        try {
            await signOut().unwrap();

            // IGNORE THIS COMMENT
            // if user signs out on protected page then this ensures 
            // they are directed to hompage first and not the auth page

            // clear token and director state
            dispatch(clearCredentials());

            // clear cached user data
            dispatch(apiSlice.util.resetApiState());

        } catch(error) {
            // parse the error message
            navigate(`/error`); 

        }
    }

    const handleAuthenticate = () => {
        navigate("/auth");
    }

    return (
        <button
            className={clsx(
                "w-full h-11 lg:w-auto lg:h-auto lg:px-4 lg:py-2 rounded-full text-sm lg:text-sm leading-[44px] lg:leading-[32px] uppercase",
                {
                    "bg-epic-green-back text-epic-green border-epic-green-back": !authenticated,
                    "bg-epic-red-back text-epic-red border-epic-red-back": authenticated,
                }
            )}
            onClick={authenticated ? handleLogout : handleAuthenticate}
            disabled={isLoading}
        >
            {authenticated ? "sign out" : "sign in"}
        </button>
    )
}